import Vue from 'vue'
import App from '@/App'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import './sass/main.sass'
import './sass/variables.scss'

import locale from '@/locale'

import VueClipboard from 'vue-clipboard2'
import VueI18n from 'vue-i18n'
import Vuelidate from 'vuelidate'
import VConfirm from './components/VDialog/VConfirm'
import VuetifyDialog from 'vuetify-dialog'

import 'vuetify-dialog/dist/vuetify-dialog.css' // remove this

Vue.config.productionTip = false

Vue.use(VueClipboard)
Vue.use(VueI18n)
Vue.use(Vuelidate)

// vuetify dialog
Vue.use(VuetifyDialog, {
  context: {
    vuetify
  }
})

Vue.prototype.$dialog.component('warning', VConfirm, {
  waitForResult: true,
  actions: {
    false: 'Cancelar',
    true: {
      text: 'Continuar',
      color: 'primary'
    }
  }
})

Vue.prototype.$dialog.message = {
  info: (message, options) => Vue.prototype.$dialog.toast({
    text: message,
    color: 'blue-grey darken-1',
    position: 'top-center',
    ...options
  }),
  error: (message, options) => Vue.prototype.$dialog.toast({
    text: message,
    color: 'red darken-1',
    position: 'top-center',
    ...options
  }),
  success: (message, options) => Vue.prototype.$dialog.toast({
    text: message,
    color: 'green darken-1',
    position: 'top-center',
    ...options
  }),
  warning: (message, options) => Vue.prototype.$dialog.toast({
    text: message,
    color: 'amber darken-1',
    position: 'top-center',
    ...options
  })
}
// end vuetify dialog

Vue.prototype.$API_BASE = process.env.VUE_APP_API_BASE
Vue.prototype.$PAY_BASE = process.env.VUE_APP_PAY_BASE

const i18n = new VueI18n({
  locale: 'es',
  messages: locale,
  silentTranslationWarn: process.env.NODE_ENV === 'production'
})

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app')
